import { deepCopy } from '@/u-components/utils/assist';
import { getAgentCategorysTree, getAgentIndustry, getAgentArea, getAgentLevel } from '@/api/refer-tree';
const productGroupsRefer = (ctrl, vm) => {
  const control = Object.assign(
    {},
    {
      page: true,
      bRefer: true,
      bread: false,
      multiple: false,
      controlType: 'Refer',
      refReturnValue: 'value',
      refName: 'value',
      queryschema: [
        {
          caption: vm.mlang('agentName'),
          name: 'agent.name',
          controlType: 'String',
          valueType: 'STRING',
          groupType: 2,
          isShowIt: true,
          placeholder: vm.mlang('agentName'),
          conditionType: 'like',
          style: { 'margin-right': '15px' }
        },
        {
          caption: vm.mlang('agentCode'),
          name: 'agent.code',
          controlType: 'String',
          valueType: 'STRING',
          groupType: 2,
          isShowIt: true,
          placeholder: vm.mlang('agentCode'),
          conditionType: 'like',
          style: { 'margin-right': '15px' }
        },
        {
          caption: vm.mlang('agentCategory'),
          name: 'agentCategoryId',
          controlType: 'TreeSelect',
          groupType: 2,
          valueType: 'LONG',
          isShowIt: true,
          placeholder: vm.mlang('agentCategory'),
          action: 'getAgentCategorysTree',
          conditionType: 'eq',
          style: { 'margin-right': '15px' }

        },
        {
          caption: vm.mlang('agentArea'),
          name: 'agentAreaId',
          controlType: 'TreeSelect',
          groupType: 2,
          valueType: 'LONG',
          isShowIt: true,
          placeholder: vm.mlang('agentArea'),
          width: 220,
          action: 'getAgentArea',
          conditionType: 'eq',
          style: {
            'margin-right': '15px'
          }
        },
        {
          caption: vm.mlang('agentLevel'),
          name: 'agentLevelId',
          controlType: 'TreeSelect',
          groupType: 2,
          valueType: 'LONG',
          isShowIt: true,
          placeholder: vm.mlang('agentLevel'),
          width: 220,
          action: 'getAgentLevel',
          conditionType: 'eq',
          style: {
            'margin-right': '15px'
          }
        },
        {
          caption: vm.mlang('agentIndustry'),
          name: 'agentIndustryId',
          controlType: 'TreeSelect',
          groupType: 2,
          valueType: 'LONG',
          isShowIt: true,
          placeholder: vm.mlang('agentIndustry'),
          width: 220,
          action: 'getAgentIndustry',
          conditionType: 'eq',
          style: {
            'margin-right': '15px'
          }
        }

      ],
      columns: [
        {
          showCaption: vm.mlang('code'),
          isShowIt: true,
          fieldName: 'code'
        },
        {
          showCaption: vm.mlang('name'),
          isShowIt: true,
          fieldName: 'name'
        }
      ],
      actions: { getAgentCategorysTree, getAgentIndustry, getAgentLevel, getAgentArea },
      type: 'string',
      op: 'eq'
    },
    ctrl
  );
  if (vm.control.isShowOrgSelect) {
    control.queryschema.unshift({
      caption: vm.mlang('org'),
      name: 'orgId',
      controlType: 'Select',
      groupType: 2,
      valueType: 'LONG',
      isShowIt: true,
      placehoder: vm.mlang('org'),
      isEnum: true,
      enumString: JSON.stringify(vm.queryschemaArry.queryOrgArr),
      conditionType: 'eq',
      disabled: !!vm.control.orgId,
      style: {
        'margin-left': '23px',
        'margin-right': '15px'
      }
    });
  }
  control.queryschema.map((v) => {
    v.queryschemaCowStyle = {
      'width': '330px'
    };
  });
  return deepCopy(control);
};
export default productGroupsRefer;
